import { Box, Text } from '@wix/design-system';
import React from 'react';
import { AUTOMATION_TIMEOUT_DURATION } from '../../constants';
import { useTranslation } from '../../hooks';
import { Timer } from './Timer';
export const TimeStatus = _ref => {
  let {
    hasTimedOut,
    onTimeout
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    verticalAlign: "middle",
    backgroundColor: "Y60",
    padding: "SP1 SP2",
    borderRadius: 4
  }, hasTimedOut ? /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('trigger.timeout.message')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('trigger.time-remaining.message')), /*#__PURE__*/React.createElement(Timer, {
    initialTime: AUTOMATION_TIMEOUT_DURATION,
    onTimeout: onTimeout
  })));
};
//# sourceMappingURL=TimeStatus.js.map